import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { IAppointmentData } from 'src/app/models/IAppointmentDetails';
import { IAttributes } from 'src/app/models/IAttributes';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';

export interface DialogData {
  headerText: string;
  title1: string;
  title2: string;
  patientMenu: IAttributes;
  selectedRow: IAppointmentData;
}
@Component({
  selector: 'app-app-confirmed-dialog',
  templateUrl: './app-confirmed-dialog.component.html',
  styleUrls: ['./app-confirmed-dialog.component.css']
})

export class AppConfirmedDialogComponent implements OnInit {
  appconfirmform: FormGroup;
  public radiotitle: string;
  public header: string;
  public tilteProvider: string;
  public titlePatient: string;
  public patientMenus: any;
  public selectedRows: any;
  public disabledButtons: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<AppConfirmedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private toastr: ToastrService, private formBuilder: FormBuilder,
    private schedulerService: SchedularServiceService, private router: Router, private crypto: AESAlgorithm) {
    this.tilteProvider = data.title1;
    this.titlePatient = data.title2;
    this.header = data.headerText;
    this.patientMenus = data.patientMenu;
    this.selectedRows = data.selectedRow;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.appconfirmform = this.formBuilder.group({
      titleA: ['',],
      titleB: ['',],
      note: ['', [Validators.required]],
      radtitle: ['',]
    });
    this.appconfirmform.markAllAsTouched();
    this.appconfirmform.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.appconfirmform);

    });
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }
  onSubmit() {
    var AppointmentObjs: IAppointmentData = this.appconfirmform.value;
    AppointmentObjs.Id = this.selectedRows.Id;
    AppointmentObjs.roomId = this.selectedRows.roomId;
    AppointmentObjs.patientId = this.selectedRows.patientId;
    AppointmentObjs.role = this.selectedRows.role;
    AppointmentObjs.userId = sessionStorage.getItem("userId").toString();
    AppointmentObjs.note = this.appconfirmform.get('note').value;
    var title = this.appconfirmform.get('radtitle').value;
    if (title == '1') {
      AppointmentObjs.reason = this.tilteProvider;
    }
    else if (title == '2') {
      AppointmentObjs.reason = this.titlePatient;
    }
    else {
      AppointmentObjs.reason = '';
    }
    if (this.header != 'Rescheduled') {
      this.schedulerService.UpdateAppointmentStatusdetails(this.patientMenus.attributeId, AppointmentObjs).subscribe(
        results => {
          this.toastr.success(results);
          this.dialogRef.close(false);
        }, (err: any) => {
          console.log(err);
        });
    }
    else {
      CommonComponents.patientId = this.selectedRows.patientId;
      sessionStorage.setItem("RescheduledNotesandReason", JSON.stringify({ note: AppointmentObjs.note, reason: AppointmentObjs.reason }));
      sessionStorage.setItem("patientId", this.selectedRows.patientId);
      sessionStorage.setItem("patientName", this.selectedRows.name);
      sessionStorage.setItem("appDate", this.selectedRows.start);
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      this.router.navigateByUrl('/NewAppointment?id=' + encodeURIComponent(this.crypto.urlParmeterEncoder(AppointmentObjs.Id)) + '&&type=' + encodeURIComponent(this.crypto.urlParmeterEncoder(AppointmentObjs.reason)) + '&&remarks=' + encodeURIComponent(this.crypto.urlParmeterEncoder(AppointmentObjs.note)));

      this.dialogRef.close(false);

    }
  }

  changeradiobtn() {
    this.disabledButtons = false;
  }

  formErrors = {
    'note': '',
  };

  validationMessages = {
    'date': {
      'note': 'note is required.',
    }
  };
  logValidationErrors(group: FormGroup = this.appconfirmform): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
}